module.exports = __webpack_public_path__ + "static/media/dashboard-lessons-analytics.01770cfd.svg";